import { DescriptionStyled } from './styled';

import clsx from 'clsx';

interface DescriptionProps {
  className?: string;
}

const Description = ({ className }: DescriptionProps) => {
  return (
    <DescriptionStyled className={clsx('Description', className)}>
      <h1 className="title">QR코드를 입력해주세요.</h1>
      <div className="description">
        로봇 뒷면에 부착된 QR코드를 입력하거나 핀번호 버튼을 눌러 핀 번호를
        입력해주세요.
      </div>
    </DescriptionStyled>
  );
};

export default Description;
